/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import classNames from 'classnames/bind';

import styles from './trademarks.module.scss';

let cx = classNames.bind(styles);

const Trademarks = () => {
	return (
		<section id='marcas' className={cx({ trademarks: true })}>
			<div className='container mx-auto flex flex-col lg:items-center mb-10'>
				<div className='flex flex-col text-ccu-green w-6/12 mb-8 pl-8'>
					<p className='text-ccu-dark text-2xl font-bold leading-tight '>
						Conoce nuestras
					</p>
					<h1 className='text-6xl font-bold leading-none text-ccu-dark-green font-Ubuntu-Bold'>
						Marcas
					</h1>
				</div>
				<div className='hidden lg:flex flex-col w-auto h-auto items-center justify-center lg:pl-20'>
					<iframe
						width='650'
						height='350'
						src='https://www.youtube-nocookie.com/embed/LML8R-eYcGc?showinfo=0&rel=0&autoplay=0&controls=0'
						frameborder='0'
						allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
						allowfullscreen
					></iframe>
				</div>
				<div className='lg:hidden flex flex-col w-auto h-auto lg:items-center lg:justify-center mx-4 lg:pl-20'>
					<iframe
						// className='w-full h-auto'
						width='100%'
						height='330'
						src='https://www.youtube-nocookie.com/embed/BAqreqSszQM?showinfo=0&rel=0&autoplay=0&controls=0'
						frameborder='0'
						allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
						allowfullscreen
					></iframe>
				</div>
			</div>
		</section>
	);
};

export default Trademarks;
